'use client';

import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';

import { cn } from '../../utils/cn/cn';
import { Notification } from '../Notification/Notification';

interface CheckboxProps extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> {
  error?: boolean;
  errorMessage?: string;
}
const Checkbox = React.forwardRef<React.ComponentRef<typeof CheckboxPrimitive.Root>, CheckboxProps>(
  ({ error, errorMessage, checked, disabled, className, children, ...props }, ref) => (
    <>
      <div className="flex items-center justify-center">
        <CheckboxPrimitive.Root
          ref={ref}
          className={cn(
            'border-color-grey-dark m-1 h-2 w-2 shrink-0 rounded-sm border disabled:opacity-35',
            className,
            error && 'border-color-error checkbox-error',
          )}
          disabled={disabled}
          checked={checked}
          {...props}
        >
          <CheckboxPrimitive.Indicator
            className={cn('data-[disabled]:text-color-grey flex items-center justify-center')}
          >
            <span className="icon-emp-checkmark h-2 w-2" />
          </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
        {children}
      </div>
      {error && errorMessage && (
        <Notification severity="error" variant="feedback" className="mt-0.5">
          {errorMessage}
        </Notification>
      )}
    </>
  ),
);

Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
